<div class=" container">
  <!-- <div class="togglebtn">
    <mat-slide-toggle (change)="toggleMapView()" disabled="true">  {{ visible ? 'End Voyage Report' : 'Mid Voyage Report' }}</mat-slide-toggle>
  </div> -->
  <br>
<app-end-voyage-reports *ngIf="!visible"></app-end-voyage-reports>
<!-- <app-mid-voyage-reports *ngIf="visible"></app-mid-voyage-reports> -->
</div>